const translations = {
    'app.hexMapLabel': 'Mapa heksów',
    'modal.close': 'X',
};

export default translations;
